<div class="h-1 w-full" *ngIf="!loaded">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex flex-col w-full preview-customer-summary primary-font" *ngIf="loaded">
    <div class="relative w-full px-6 sm:px-6 sm:py-8 bg-accent-100 dark:bg-accent-700 z-0">
        <div class="flex items-center justify-end w-full max-w-3xl mx-auto">
            <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                matTooltipPosition="above"
                class="mat-focus-indicator mat-tooltip-trigger mat-icon-button mat-button-base" tabindex="0"
                (click)="closeDrawer()">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" fit=""
                        height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </mat-icon>
            </button>
        </div>
    </div>
    <div class="relative flex flex-col flex-auto z-10 primary-container-height">
        <div class="mat-drawer-inner-container">
            <div class="-mt-8 flow-root px-4 sm:flex sm:items-end sm:px-6 pb-2">
                <div class="-m-1 flex">
                    <div class="inline-flex overflow-hidden rounded-lg border-4 border-white flex-shrink-0 shadow-md">
                        <img *ngIf="customerDetails.profile_picture"
                            class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                            src="{{customerDetails.profile_picture}}" alt="">
                        <div *ngIf="!customerDetails.profile_picture && customerDetails.customer_first_name"
                            class="flex items-center justify-center overflow-hidden uppercase text-8xl font-bold leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30">
                            {{customerDetails.customer_first_name[0]}}
                        </div>
                    </div>
                </div>
                <div class="m-4 sm:ml-6 sm:flex-1 w-2/4">
                    <div class="flex items-center">
                        <h3 class="text-xl font-bold text-gray-900 sm:text-2xl truncate"
                            matTooltip="{{customerDetails.customer_first_name}} {{customerDetails.customer_last_name ?? ''}}">
                            {{customerDetails.customer_first_name}}
                            {{customerDetails.customer_last_name ?? ''}}</h3>
                    </div>
                    <p class="text-base text-gray-600 mt-1 truncate" *ngIf="customerDetails.customer_category">
                        {{customerDetails.customer_category.category_name}}</p>
                </div>
                <div class="my-6 ml-auto">
                    <a target="_blank" class="hidden" #viewCustomerDetails href="{{getRedirectLink()}}"></a>
                    <button mat-icon-button matTooltip="{{'text.view_details.new_tab' | translate}}"
                        matTooltipPosition="above" (click)="viewCustomerDetails.click($event)">
                        <mat-icon class="icon-size-6">open_in_new</mat-icon>
                    </button>
                </div>
            </div>

            <div>
                <div class="block">
                    <div class="border-b border-gray-200">
                        <nav class="-mb-px flex space-x-8 ml-4" aria-label="Tabs">
                            <a *ngFor="let tab of tabs" rel="{{tab.rel}}_container"
                                class="whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-base cursor-pointer items-center"
                                (click)="changeViewMode(tab.dataKey)" [ngClass]="{
                                    'border-indigo-500 text-indigo-600': viewMode === tab.dataKey,
                                    'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200': viewMode !== tab.dataKey
                                  }">
                                {{tab.displayKey | translate}}
                                <div class="ml-2" *ngIf="tab.dataKey === 'Notes' && notesCount">
                                    <badge [options]="getBadgeOptions()" class="primary-font"></badge>
                                </div>
                            </a>
                        </nav>
                    </div>
                </div>
            </div>

            <div [ngSwitch]="viewMode" class="tabs-container-height overflow-y-auto overflow-x-hidden zuper-scrollbar"
                [ngClass]="{ 'bg-gray-100': viewMode === 'Notes' }">
                <div class="flex flex-col" id="customer_primary_details_container" *ngSwitchCase="'PrimaryDetails'">
                    <div class="flex flex-col space-y-6 py-6 w-full border-b">
                        <div class="flex px-5" *ngIf="customerDetails.customer_email">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="mail"
                                data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
                                    width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                                    </path>
                                </svg></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6"><a target="_blank"
                                        class="hover:underline text-primary-500 text-base"
                                        href="mailto:{{customerDetails.customer_email}}">
                                        {{customerDetails.customer_email}} </a>
                                </div>
                            </div>
                        </div>
                        <div class="flex px-5"
                            *ngIf="customerDetails.customer_contact_no && (customerDetails.customer_contact_no.home || customerDetails.customer_contact_no.work || customerDetails.customer_contact_no.mobile)">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="phone"
                                data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
                                    width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                                    </path>
                                </svg></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6"
                                    *ngIf="customerDetails.customer_contact_no.home">
                                    <div class="text-base">
                                        <a href="tel:{{customerDetails.customer_contact_no.home}}">
                                            {{customerDetails.customer_contact_no.home}}
                                        </a>
                                    </div>
                                    <div class="text-base truncate text-secondary"><span class="mx-2">•</span><span
                                            class="font-medium">{{'home' | translate}}</span>
                                    </div>

                                </div>
                                <div class="flex items-center leading-6"
                                    *ngIf="customerDetails.customer_contact_no.work">
                                    <div class="text-base">
                                        <a href="tel:{{customerDetails.customer_contact_no.work}}">
                                            {{customerDetails.customer_contact_no.work}}
                                        </a>
                                    </div>
                                    <div class="text-base truncate text-secondary"><span class="mx-2">•</span><span
                                            class="font-medium">{{'text.work' | translate}}</span>
                                    </div>
                                </div>
                                <div class="flex items-center leading-6"
                                    *ngIf="customerDetails.customer_contact_no.mobile">
                                    <div class="text-base">
                                        <a href="tel:{{customerDetails.customer_contact_no.mobile}}">
                                            {{customerDetails.customer_contact_no.mobile}}
                                        </a>
                                    </div>
                                    <div class="text-base truncate text-secondary"><span class="mx-2">•</span><span
                                            class="font-medium">{{'text.mobile' | translate}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex px-5 items-center" *ngIf="customerDetails.customer_organization">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="mail"
                                data-mat-icon-namespace="heroicons_outline">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" fit="" height="100%" width="100%"
                                    preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
                                    </path>
                                </svg>
                            </mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6">
                                    <span class="text-base text-gray-700 font-medium"
                                        *ngIf="customerDetails.customer_organization.is_deleted || !isOrganizationAccessible">
                                        {{customerDetails.customer_organization.organization_name}}
                                    </span>
                                    <a class="text-base text-gray-700 font-medium hover:underline hover:text-primary cursor-pointer"
                                        target="_blank"
                                        [routerLink]="utilityService.getLink('ORGANIZATION', customerDetails.customer_organization.organization_uid)"
                                        *ngIf="!customerDetails.customer_organization.is_deleted && isOrganizationAccessible">
                                        {{customerDetails.customer_organization.organization_name}}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="flex px-5" *ngIf="customerDetails.customer_description">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="mail"
                                data-mat-icon-namespace="heroicons_outline">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" fit="" height="100%" width="100%"
                                    preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M4 6h16M4 12h16M4 18h7"></path>
                                </svg>
                            </mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex leading-6">
                                    <span class="text-base text-gray-700 font-medium tinymce-text-inner-html"
                                        [innerHTML]="customerDetails.customer_description | safeHtml: false"></span>
                                </div>
                            </div>
                        </div>
                        <div class="flex px-5" *ngIf="customerDetails.customer_tags?.length">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="mail"
                                data-mat-icon-namespace="heroicons_outline">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" fit="" height="100%" width="100%"
                                    preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z">
                                    </path>
                                </svg>
                            </mat-icon>
                            <div class="min-w-0 ml-6 flex flex-wrap">
                                <ng-container *ngFor="let tag of customerDetails.customer_tags">
                                    <badge class="mr-2 mb-2 cursor-pointer" *ngIf="tag"
                                        [options]="getTagBadgeOptions(tag)" [matTooltip]="tag"
                                        [matTooltipPosition]="'below'"></badge>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-secondary font-bold text-base primary-font">
                                    {{'customers.preview.panel.address_header' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="px-6 py-2 primary-font"
                                *ngIf="customerDetails.customer_address && (customerDetails.customer_address.street || customerDetails.customer_address.state)">
                                <span class="cursor-pointer absolute right-0 pt-1 pr-3 z-50"
                                    *ngIf="customerDetails.customer_address.geo_cordinates?.length > 1"
                                    [matTooltip]="('text.view_on_map' | translate)"
                                    matTooltipPosition="left">
                                    <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                                        target="_blank"
                                        href="{{utilityService.getMapsCoordinatesUrl(customerDetails.customer_address.geo_cordinates[0], customerDetails.customer_address.geo_cordinates[1])}}">
                                        <em class="ti ti-location icon-size-4.5 font-semibold"></em>
                                    </a>
                                </span>
                                <p class="font-bold leading-5 truncate text-base text-gray-600 mb-3 ml-1">
                                    {{'text.service_address' | translate}}</p>
                                <div class="px-3 text-gray-500 font-medium">
                                    <p *ngIf="customerDetails.customer_address.first_name"
                                        class="text-base mb-2">
                                        {{customerDetails.customer_address.first_name}}
                                        {{customerDetails.customer_address.last_name ?? ''}}</p>
                                    <p *ngIf="customerDetails.customer_address.street" class="text-base mb-2">
                                        {{customerDetails.customer_address.street}}</p>
                                    <p *ngIf="customerDetails.customer_address.landmark" class="text-base mb-2">
                                        {{customerDetails.customer_address.landmark}}</p>
                                    <p *ngIf="customerDetails.customer_address.city" class="text-base mb-2">
                                        {{customerDetails.customer_address.city}}</p>
                                    <p *ngIf="customerDetails.customer_address.state" class="text-base mb-2">
                                        {{customerDetails.customer_address.state}}
                                        {{customerDetails.customer_address.zip_code ? '- ' +
                                        customerDetails.customer_address.zip_code : '' }}</p>
                                    <p *ngIf="customerDetails.customer_address.country" class="text-base">
                                        {{customerDetails.customer_address.country}}</p>
                                </div>
                            </div>
                            <div class="px-6 py-2 border-t primary-font"
                                *ngIf="customerDetails.customer_billing_address && (customerDetails.customer_billing_address.street || customerDetails.customer_billing_address.state)">
                                <span class="cursor-pointer absolute right-0 pt-1 pr-3 z-50"
                                    *ngIf="customerDetails.customer_billing_address.geo_cordinates?.length > 1"
                                    [matTooltip]="('text.view_on_map' | translate)"
                                    matTooltipPosition="left">
                                    <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                                        target="_blank"
                                        href="{{utilityService.getMapsCoordinatesUrl(customerDetails.customer_billing_address.geo_cordinates[0], customerDetails.customer_billing_address.geo_cordinates[1])}}">
                                        <em class="ti ti-location icon-size-4.5 font-semibold"></em>
                                    </a>
                                </span>
                                <p class="font-bold leading-5 truncate text-base text-gray-600 mb-3 ml-1">
                                    {{'billing.address.text' | translate}}</p>
                                <div class="px-3 text-gray-500 font-medium">
                                    <p *ngIf="customerDetails.customer_billing_address.first_name"
                                        class="text-base mb-2">
                                        {{customerDetails.customer_billing_address.first_name}}
                                        {{customerDetails.customer_billing_address.last_name ?? ''}}</p>
                                    <p *ngIf="customerDetails.customer_billing_address.street" class="text-base mb-2">
                                        {{customerDetails.customer_billing_address.street}}</p>
                                    <p *ngIf="customerDetails.customer_billing_address.landmark" class="text-base mb-2">
                                        {{customerDetails.customer_billing_address.landmark}}</p>
                                    <p *ngIf="customerDetails.customer_billing_address.city" class="text-base mb-2">
                                        {{customerDetails.customer_billing_address.city}}</p>
                                    <p *ngIf="customerDetails.customer_billing_address.state" class="text-base mb-2">
                                        {{customerDetails.customer_billing_address.state}}
                                        {{customerDetails.customer_billing_address.zip_code ? '- ' +
                                        customerDetails.customer_billing_address.zip_code : '' }}</p>
                                    <p *ngIf="customerDetails.customer_billing_address.country" class="text-base">
                                        {{customerDetails.customer_billing_address.country}}</p>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <mat-accordion *ngFor="let key of object.keys(customFieldGroups)">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-secondary font-bold text-base primary-font">
                                    {{customFieldGroups[key].isDefaultGroup ? ('text.other_details' |
                                    translate) :
                                    customFieldGroups[key].headerName}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="pt-4 px-10 primary-font">
                                <custom-fields [options]="getcustomFieldOptions(customFieldGroups[key].custom_fields)"></custom-fields>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div class="flex flex-col h-full" id="customer_notes_container" *ngSwitchCase="'Notes'">
                    <div class="flex flex-col flex-auto overflow-auto zuper-scrollbar p-5">
                        <notes [module]="'CUSTOMERS'" [moduleUID]="customerDetails.customer_uid"
                            [options]="notesOptions" (eventEmitter)="notesEventHandler($event)"></notes>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>